// Convierte una fecha ISO (AAAA-MM-DD) a día/mes/año.
export const formatDate=(iso)=>{
  const [year,month,day]=String(iso || '').split('-');
  return year && month && day ? `${day}/${month}/${year}` : (iso || '');
};
